// Module
var code = "<span class=\"dc-status mcp-admin-contract-status\" ng-class=\"$ctrl.statusCssClass\"><span class=\"mcp-admin-contract-status__label\">{{$ctrl.statusLabel}}</span></span> ";
// Exports
module.exports = code;